import { cn } from "@/lib/utils";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

export interface FormSelectOption {
  label: string;
  value: string;
}

export interface FormSelectProps {
  label?: string;
  value?: string;
  onValueChange?: (value: string) => void;
  options: FormSelectOption[];
  placeholder?: string;
  error?: string;
  hint?: string;
  requiredMark?: boolean;
  disabled?: boolean;
  triggerClassName?: string;
  containerClassName?: string;
}

const FormSelect = ({
  label,
  value,
  onValueChange,
  options,
  placeholder = "Select...",
  error,
  hint,
  requiredMark,
  disabled,
  triggerClassName,
  containerClassName,
}: FormSelectProps) => {
  return (
    <div className={cn("space-y-2", containerClassName)}>
      {label && (
        <Label>
          {label}
          {requiredMark && <span className="text-destructive ml-0.5">*</span>}
        </Label>
      )}
      <Select value={value} onValueChange={onValueChange} disabled={disabled}>
        <SelectTrigger className={cn(error && "border-destructive", triggerClassName)}>
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {options.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {error ? (
        <p className="text-xs text-destructive">{error}</p>
      ) : hint ? (
        <p className="text-xs text-muted-foreground">{hint}</p>
      ) : null}
    </div>
  );
};

export default FormSelect;
